import { NavigationData } from "./types";

export const uiZIndexDefault = 10;

export const EYECON_SIZE = { width: 8, height: 8 };

export const LEFT_RIGHT_ARROW_SIZE = {
	width: 9,
	height: 20,
};

export const ARROW_SIZE = {
	width: 20,
	height: 9,
};

export const NAV_BUTTON_SIZE = {
	width: 5,
	height: 9,
};

export const CUSTOM_INTERACTIVE_COMPONENTS = ["USER_PROFILE", "NAV_MENU"];

export const GLOBAL_FOCUS_IDS = {
	LEFT_ARROW: "nav-left",
	RIGHT_ARROW: "nav-right",
	CENTER_ARROW: "nav-center",
	HOME: "nav-home",
	BACK: "nav-back",
	USER_PROFILE: "user-profile",
};

export const LEFT_ARROW_DEFAULT_POSITION = {
	hitbox: { x: 0, y: 0, width: 18, height: 100 },
	icon: {
		x: 0,
		y: 45,
		...LEFT_RIGHT_ARROW_SIZE,
	},
};

export const BACK_DEFAULT_POSITION = {
	hitbox: { x: 4, y: 70, width: 5, height: (5 * 16) / 9, zIndex: uiZIndexDefault },
	icon: { x: 4, y: 70, ...NAV_BUTTON_SIZE, zIndex: uiZIndexDefault },
};
export const BACK_DEFAULT_DATA: NavigationData = {
	id: GLOBAL_FOCUS_IDS.BACK,
	up: null,
	down: GLOBAL_FOCUS_IDS.HOME,
	left: GLOBAL_FOCUS_IDS.HOME,
	right: null,
	initialFocus: false,
};

export const USER_PROFILE_DEFAULT_NAV_DATA: NavigationData = {
	id: GLOBAL_FOCUS_IDS.USER_PROFILE,
	up: null,
	down: null,
	left: null,
	right: null,
	initialFocus: false,
};

export const HOME_DEFAULT_POSITION = {
	hitbox: { x: 4, y: 85, width: 5, height: (5 * 16) / 9, zIndex: uiZIndexDefault },
	icon: { x: 4, y: 85, ...NAV_BUTTON_SIZE, zIndex: uiZIndexDefault },
};

export const HOME_DEFAULT_DATA: NavigationData = {
	id: GLOBAL_FOCUS_IDS.HOME,
	initialFocus: false,
	up: null,
	down: null,
	left: null,
	right: GLOBAL_FOCUS_IDS.BACK,
};
export const RIGHT_ARROW_DEFAULT_POSITION = {
	hitbox: { x: 82, y: 0, width: 18, height: 100 },
	icon: {
		x: 90,
		y: 45,
		...LEFT_RIGHT_ARROW_SIZE,
	},
};

export const CENTER_ARROW_DEFAULT_POSITION = {
	hitbox: { x: 10, y: 85, width: 80, height: 15 },
	icon: {
		x: 40,
		y: 87,
		...ARROW_SIZE,
	},
};
export const CENTER_ARROW_DEFAULT_DATA: NavigationData = {
	id: GLOBAL_FOCUS_IDS.CENTER_ARROW,
	up: null,
	down: null,
	left: GLOBAL_FOCUS_IDS.BACK,
	right: null,
	initialFocus: false,
};

export const LEFT_ARROW_DEFAULT_DATA: NavigationData = {
	id: GLOBAL_FOCUS_IDS.LEFT_ARROW,
	up: null,
	down: null,
	left: GLOBAL_FOCUS_IDS.BACK,
	right: GLOBAL_FOCUS_IDS.USER_PROFILE,
	initialFocus: false,
};

export const RIGHT_ARROW_DEFAULT_DATA: NavigationData = {
	id: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
	up: null,
	down: null,
	left: null,
	right: null,
	initialFocus: false,
};
